export default __webpack_public_path__ + "static/presse-fest-ruhpolding-1-preview-b40decdfdde686af64a6f596c407bb9d.jpg";